var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgVariants = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 24,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  stroke: "currentColor",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "m12 7 1.119-1.12c.706-.706 1.06-1.059 1.431-1.264a3 3 0 0 1 2.899 0c.372.205.725.558 1.431 1.265v0c.649.648.973.972 1.171 1.318a3 3 0 0 1 .13 2.734c-.165.363-.457.716-1.04 1.423L12 20m-4 2h9.5c1.398 0 2.097 0 2.648-.228a3 3 0 0 0 1.624-1.624C22 19.597 22 18.898 22 17.5V17c0-.93 0-1.395-.102-1.777a3 3 0 0 0-2.122-2.12C19.395 13 18.93 13 18 13v0M7.5 17a.5.5 0 0 1-1 0m1 0a.5.5 0 0 0-1 0m1 0h-1"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M2 6.8c0-1.68 0-2.52.327-3.162a3 3 0 0 1 1.311-1.311C4.28 2 5.12 2 6.8 2h.4c1.68 0 2.52 0 3.162.327a3 3 0 0 1 1.311 1.311C12 4.28 12 5.12 12 6.8V22H6.8c-1.68 0-2.52 0-3.162-.327a3 3 0 0 1-1.311-1.311C2 19.72 2 18.88 2 17.2V6.8Z"
})));
export default SvgVariants;